import { defineAction, object, string } from '~/prix'
import inventoryByResidenceAction from './inventoryByResidence.action.json' with { type: 'json' }
import { z } from 'zod'
import { residenceObject } from '~/packages/general/residence/residenceObject'
import { inventoryObject } from '../inventoryObject'
import { communityObject } from '~/packages/geo/community/communityObject'

const inventoryByResidenceDefinition = defineAction({
  ...inventoryByResidenceAction,

  input: z.object({
    residenceId: z.string().nullish(),
    communityId: z.string().nullish(),
  }),
  output: z.object({
    success: z.boolean(),
    total: z.number(),
    message: z.string(),
    data: z.array(
      z.object({
        community: communityObject.nullish(),
        residences: z.array(
          z.object({
            residence: residenceObject,
            inventories: z.array(inventoryObject),
          }),
        ),
      }),
    ),
  }),
})

export default inventoryByResidenceDefinition
